// Penalty shootouts.
//
// MLS NEXT Flex has no draws: a fixture level at full time goes straight to
// penalties. The shootout does not change the scoreline — the result is still
// recorded and shown as the draw it was — but it decides the points, 2 to the
// winner and 1 to the loser against 3 for a win in regulation.
//
// So a Flex scoreline of 2-2 is incomplete on its own: it looks like a fixture
// that settled for a point when in fact someone walked away with two. The
// annotation is what closes that gap.
//
// League fixtures never carry one, and neither do Flex fixtures decided in
// regulation, so every helper here returns nothing rather than a placeholder.

/** True when this fixture was decided on penalties. */
export function hasShootout(game) {
  return game != null
    && game.home_pk != null
    && game.away_pk != null
    && game.home_pk !== game.away_pk;
}

/**
 * The shootout as it is conventionally written: "(4 : 3)".
 *
 * Same separator as the full-time score it sits under, and the same home-away
 * order, so the side listed first in one is the side listed first in the other
 * and the two read as a pair rather than as two unrelated numbers.
 *
 * Deliberately not labelled "pen" in the text. Set in smaller type directly
 * beneath the full-time score, a second bracketed pair is already understood as
 * the shootout wherever football is written down; the word is carried in the
 * title instead, for anyone it is not obvious to.
 */
export function shootoutSuffix(game) {
  if (!hasShootout(game)) return '';
  return `(${game.home_pk} : ${game.away_pk})`;
}

/** "won on penalties" / "lost on penalties", for a title attribute. */
export function shootoutTitle(game) {
  if (!hasShootout(game)) return '';
  const homeWon = game.home_pk > game.away_pk;
  const winner = homeWon ? game.home_team : game.away_team;
  return `Level at full time. ${winner} won ${game.home_pk}-${game.away_pk} `
    + 'on penalties: 2 points, 1 to the other side.';
}
